module.exports = __webpack_public_path__ + "img/almha.ea31d308.jpg";